import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { Lock } from 'lucide-react'

/**
 * Bottom-of-page launch bar, repeating the hero's CTA for anyone who read to
 * the end. Starts outreach rather than linking — it used to link to the page it
 * is rendered on, which did nothing.
 */
export function OutreachAcquisitionLaunchBar({
  noMatches = false,
  onStart,
  isStarting = false,
  startError = null,
}: {
  noMatches?: boolean
  onStart: () => void
  isStarting?: boolean
  startError?: string | null
}) {
  const title = noMatches ? 'No matching investors yet.' : 'Ready when you are.'
  const subtitle = noMatches
    ? "Sorry, we haven't found matching investors for your startup yet. Outreach will unlock once your first matches arrive."
    : (startError ?? "Your first 30 days are free. We'll walk you through a few quick setup steps.")

  return (
    <section className="relative flex flex-col items-start justify-between gap-6 overflow-hidden rounded-2xl border border-primary/30 bg-gradient-to-br from-card/60 to-card/20 px-8 py-7 lg:flex-row lg:items-center">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-[10%] -top-1/2 size-[360px] rounded-full bg-primary/10 blur-3xl"
      />
      <div className="relative z-10">
        <div className="text-[19px] font-bold tracking-[-0.01em] text-foreground">{title}</div>
        <div className="mt-1 text-[13.5px] text-foreground/85">{subtitle}</div>
      </div>
      <div className="relative z-10 flex flex-col items-start gap-2 lg:items-end">
        {noMatches ? (
          <CtaButton size="lg" disabled icon={<Lock />}>
            No matches yet
          </CtaButton>
        ) : (
          <CtaButton size="lg" onClick={onStart} loading={isStarting} arrow>
            {isStarting ? 'Starting…' : 'Start free trial'}
          </CtaButton>
        )}
      </div>
    </section>
  )
}
